import React from "react";

import { Model } from "react3l-common";
import {
  APP_USER_DETAIL_ROUTE,
  APP_USER_MASTER_ROUTE,
} from "config/route-consts";
import authenticationService from "services/common-services/authentication-service";
import appMessageService, {
  messageType,
} from "services/common-services/app-message-service";

export class Site extends Model {
  public id?: number;
  public code?: string;
  public name?: string;
  public icon?: string;
}

export class AppUserSiteMapping extends Model {
  public appUserId?: number;
  public siteId?: number;
  public enabled?: boolean;
  public site?: Site;
}

export function useProfileMenu() {
  const user = JSON.parse(localStorage.getItem("currentUserInfo"));

  const [profileDrop, setProfileDrop] = React.useState(false);
  const handleLogout = React.useCallback(() => {
    authenticationService.logout();
  }, []);
  const handleClickToProfile = React.useCallback(() => {
    window.location.href = `${APP_USER_DETAIL_ROUTE}?id=${user?.id}`;
  }, [user?.id]);
  const handleClickToChangePassword = React.useCallback(() => {
    window.location.href = `${APP_USER_MASTER_ROUTE}?idChangePassword=${user?.id}`;
  }, [user?.id]);

  const handleToggerProfile = React.useCallback(() => {
    setProfileDrop(!profileDrop);
  }, [profileDrop]);

  const handleMouseLeaveAll = React.useCallback(() => {
    setProfileDrop(false);
  }, []);

  const handleGetSwitchAccountCode = React.useCallback(() => {
    appMessageService.messageFactory({
      type: messageType.WARNING,
      title: "Chuyển tài khoản",
      description:
        "Vui lòng chờ trong dây lát, hệ thống đang thực hiện chuyển trang",
    });
    authenticationService.getSwitchAccountCode().then((res: any) => {
      if (res.data) {
        const currentPage = `${window.location.protocol}//${window.location.hostname}/landing-page`; //:${window.location.port} trước landingpage
        window.location.href = `${res.directUrl}/switchAccount?redirect_url=${currentPage}&code=${res.data}`;
      }
    });
  }, []);

  return {
    user,
    handleLogout,
    handleClickToChangePassword,
    handleToggerProfile,
    profileDrop,
    handleMouseLeaveAll,
    handleClickToProfile,
    handleGetSwitchAccountCode,
  };
}
